// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-header {
  background-color: white;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/app/components/additional-content/additional-content-wrapper.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACJ","sourcesContent":[".card-header {\n    background-color: white;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
